import React, { useEffect, useState } from 'react'
import Pagination from './Pagination';
import SideBar from './SideBar';
import { useLocation, useParams } from 'react-router-dom';
import loader from "../assets/images/loader.gif";
import axiosClient from '../axios';
import Pagination_2 from './Pagination_2';
import moment from 'moment';
import EditOfferAvailabilityModal from '../helperComponent/offerConfig/EditOfferAvailabilityModal';

const OfferCountryAvailability = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState()
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedOffer, setSelectedOffer] = useState(null);

    const [offerFilterData, setOfferFilterData] = useState({
        page: 0,
        limit: 100,
    });

    const getallOfferAvailability = () => {
        console.log("inside id access or not ===>", id)
        setLoading(false);
        axiosClient
            .post(`/admin/offerAvailabilityInCountry?offer_id=${id}`, offerFilterData)
            .then((res) => {
                setData(res?.data?.response);
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(true);
            });
    };

    const handleEditClick = (offer) => {
        setSelectedOffer(offer);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedOffer(null);
    };

    const handleSubmit = (formData) => {
        console.log("Form data to submit:", formData);
        console.log("Selected offer ID:", selectedOffer._id);
        setLoading(false);
        axiosClient
            .put(`/admin/updateOfferAvailability/${selectedOffer._id}`, formData)
            .then((res) => {
                console.log("Updated successfully:", res.data);
                alert("Updated successfully!");
                getallOfferAvailability();
                handleModalClose();
            })
            .catch((error) => {
                console.log("Error updating:", error);
                alert("Error updating offer availability");
            })
            .finally(() => {
                setLoading(true);
            });
    };

    useEffect(() => {
        console.log("get offers userEffect");
        getallOfferAvailability();
    }, [offerFilterData.page, offerFilterData.limit]);

    return (
        <>
            <SideBar handleSideBar={true} activeTab={"AllOffers"} />
            <div className="screen">
                <h3>Offer Available In Country</h3>

                {loading ? (
                    <div className="profileInfoBox table">
                        <>
                            {data?.length != 0 ? (
                                <div style={{ width: "100%" }} className="container app-body">
                                    <div className="tabel-scrol">
                                        <table id="users">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px" }}>S.NO.</th>
                                                    <th style={{ width: "130px" }}>Offer Name</th>
                                                    <th style={{ width: "150px" }}>Provider Name</th>
                                                    <th style={{ width: "200px" }}>payout</th>
                                                    <th style={{ width: "100px" }}>availabelOn</th>
                                                    <th style={{ width: "70px" }}>category</th>
                                                    <th style={{ width: "100px" }}>countries</th>
                                                    <th style={{ width: "100px" }}>By Admin</th>
                                                    <th style={{ width: "100px" }}>Is Ads</th>
                                                    <th style={{ width: "200px" }}>Created At</th>
                                                    <th style={{ width: "200px" }}>Updated At</th>
                                                    <th style={{ width: "100px" }}>Is Active</th>
                                                    <th style={{ width: "100px" }}>Is Featured</th>
                                                    <th style={{ width: "100px" }}>Is Popular</th>
                                                    <th>EPC</th>
                                                    <th style={{ width: "80px" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.map((val, key) => {
                                                    return (
                                                        <tr key={key + 1}>
                                                            <td>
                                                                {offerFilterData?.page *
                                                                    offerFilterData?.limit +
                                                                    (key + 1)}
                                                            </td>
                                                            <td className="clickabuetd">
                                                                {val?.offer_id?.name}
                                                            </td>
                                                            <td>{val?.provider?.name}</td>
                                                            <td>
                                                                {val?.totalPayOutAmt}
                                                            </td>
                                                            <td>
                                                                {val.availabelOn.includes(1) &&
                                                                    val.availabelOn.includes(2) &&
                                                                    val.availabelOn.includes(3)
                                                                    ? "Android, Desktop, Apple"
                                                                    : val.availabelOn.includes(1) &&
                                                                        val.availabelOn.includes(2)
                                                                        ? "Android, Desktop"
                                                                        : val.availabelOn.includes(1) &&
                                                                            val.availabelOn.includes(3)
                                                                            ? "Android, Apple"
                                                                            : val.availabelOn.includes(2) &&
                                                                                val.availabelOn.includes(3)
                                                                                ? "Desktop, apple"
                                                                                : val.availabelOn.includes(1)
                                                                                    ? "Android"
                                                                                    : val.availabelOn.includes(2)
                                                                                        ? "Desktop"
                                                                                        : val.availabelOn.includes(3)
                                                                                            ? "Apple"
                                                                                            : ""}
                                                            </td>
                                                            <td>{val?.category}</td>
                                                            <td>
                                                                {val?.countryCode}
                                                            </td>
                                                            <td>{val?.by_admin ? "true" : "false"}</td>
                                                            <td>{val?.is_ads ? "true" : "false"}</td>
                                                            <td>
                                                                {moment
                                                                    .utc(val?.created_at)
                                                                    .local()
                                                                    .format("MMM Do YY, h:mm:ss a")}
                                                            </td>
                                                            <td>
                                                                {moment
                                                                    .utc(val?.updated_at)
                                                                    .local()
                                                                    .format("MMM Do YY, h:mm:ss a")}
                                                            </td>
                                                            <td>{val?.is_active ? "true" : "false"}</td>
                                                            <td>{val?.is_featured ? "true" : "false"}</td>
                                                            <td>{val?.is_popular ? "true" : "false"}</td>
                                                            <td>{val?.epc?.toFixed(2)}</td>
                                                            <td>
                                                                <button
                                                                    className="btn-edit"
                                                                    onClick={() => handleEditClick(val)}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div>
                                        <Pagination_2
                                            filterDataInput={offerFilterData}
                                            setFilterDataInput={setOfferFilterData}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <h1>No Data Found</h1>
                            )}
                        </>
                    </div>
                ) : (
                    <>
                        <div className="loaderImage">
                            <img src={loader} alt="loader" />
                        </div>
                    </>
                )}

                <EditOfferAvailabilityModal
                    isOpen={isModalOpen}
                    onClose={handleModalClose}
                    data={selectedOffer}
                    onSubmit={handleSubmit}
                />
            </div>
        </>
    )
}

export default OfferCountryAvailability